<template>
    <restaurant-detail
        class="restaurant-phone-number"
        :title="$snippet('restaurant_phone_number_title', 'telephone')"
    >
        <p>
            <a
                :href="`tel:${ tel }`"
                v-test:telLink
            >
                {{ tel }}
            </a>
        </p>
    </restaurant-detail>
</template>

<script>
    import RestaurantDetail from '../../molecules/RestaurantDetail/RestaurantDetail';

    export default {
        name: 'restaurant-phone-number',

        components: { RestaurantDetail },

        props: {
            tel: {
                type: String,
                required: true,
            },
        },
    };
</script>

<style lang="scss" scoped>
    a:not(:hover):not(:focus) {
        color: inherit;
    }
</style>
